export default __webpack_public_path__ + "static/media/img7.08fa9853.jfif";